<script setup lang="ts">import { ref as _ref } from 'vue';

import __MACROS_useVModel from "/vue-macros/define-models/use-vmodel";
defineProps({
  value: null
});
import { watch } from 'vue';
import { AlertingHookService, AlertingHookDto } from '@/api';

interface Emit {
  (event: 'input', value: AlertingHookDto[]): void
}
const emit = defineEmits(["input"]);

const { value: selectedMsTeamWebhooks } = __MACROS_useVModel(["value", undefined, "input"]);

let loading = _ref(false);
let alertingHooks = _ref<AlertingHookDto[]>([]);
const searchString = _ref('');

const clear = () => {
  selectedMsTeamWebhooks.value = [];
  emit('input', selectedMsTeamWebhooks.value);
};

const fetchMsTeamsWebhooksTags = async () => {
  loading.value = true;
  const { data } = await AlertingHookService.getAllAlertingHooks({ type: AlertingHookDto.type.MS_TEAMS, itemsPerPage: -1 });
  alertingHooks.value = data!;
  loading.value = false;
};

watch(() => searchString.value, () => {
  fetchMsTeamsWebhooksTags();
});
</script>

<template lang="pug">
v-autocomplete.tag-selector#msteams-tag-selector(
  v-model="selectedMsTeamWebhooks"
  v-bind='$attrs'
  v-on='$listeners'
  :loading="loading"
  :items="alertingHooks"
  :search-input.sync="searchString"
  :hint="$t('monitor_wizard.notification_method.microsoft_teams_channels_hint')"
  :menu-props="{'maxHeight': 200}"
  @change="searchString=''"
  @click:clear="clear"
  :placeholder="$t('common.words.type_to_search')"
  item-value="id"
  item-text="name"
  data-track="msteams-tag-selector"
  cache-items dense outlined
  hide-no-data persistent-hint
  return-object multiple clearable )

  template(v-slot:label)
    span {{ $t('monitor_wizard.notification_method.microsoft_teams_channels') }}

</template>
